import { getLeaderboardLink } from 'utils/custom';

export default data => `${window.location.origin}${getLeaderboardLink(data)}`;
